import { memo } from "react";

import styled from "@emotion/styled";

import { Finding } from "stores/FindingStore";

// -----------------------------------------------------------------------------

const NoneFindingDetails = memo(function NoneFindingDetails({
  finding,
}: NoneFindingDetailsProps): JSX.Element {
  const details: string =
    Object.keys(finding.details).length > 0
      ? JSON.stringify(finding.details, undefined, 2).trim()
      : "No details.";

  //
  return <JSONBox>{details}</JSONBox>;
});

export default NoneFindingDetails;

// -----------------------------------------------------------------------------

interface NoneFindingDetailsProps {
  finding: Finding;
}

// -----------------------------------------------------------------------------

const JSONBox = styled.pre`
  margin: 0;
  word-break: break-all;
  white-space: pre-wrap;
`;
